import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { MarketplaceItemExtended } from '../marketplace/models/marketplace-item-extended.model';
import { Cart } from './models/cart.model';

export interface CartState extends EntityState<Cart> {}
/**
 * This cart store will consist of the
 * collection of cart item entities.
 * Items being of type marketplace items or
 * portal products, as there is 2 add to cart processes.
 * Within the cart query and service there is logic to
 * split the item types when updating or making a query to
 * this cart store.
 */
@Injectable({ providedIn: 'root' })
@StoreConfig({
  name: 'cart',
})
export class CartStore extends EntityStore<CartState> {
  constructor() {
    super();
  }

  /**
   * @param cartItem The item to be updated.
   * @param quantitySelected The quantity to be added.
   * @param updateFromCart Update quantity from cart which the quantity is already in cart,
   *  if get more from cartItem purchaseQuantity it will duplicate.
   * @returns Update the quantity of a marketplace item,
   * which already exists within the cart store.
   * This will also update the total price of the item.
   */
  updateQuantityOfItem(cartItem: Cart, quantitySelected: number, updateFromCart?: boolean) {
    let newQuantity = updateFromCart ? quantitySelected : cartItem.purchaseQuantity + quantitySelected;
    this.update(cartItem.id, {
      purchaseQuantity: newQuantity,
      totalPrice: (cartItem.productData as MarketplaceItemExtended).MerchantValue * newQuantity,
    });
  }
}
